import { getTypeOrNull } from '@spotify/confidence-graphql';

import { useCurrentUser } from '../useCurrentUser';

export const useCurrentIdentity = ({ skip }: { skip?: boolean } = {}) => {
  const { currentUser, isLoading, error } = useCurrentUser({ skip });
  const currentIdentity = getTypeOrNull(currentUser?.identity);
  return {
    currentIdentity,
    isLoading,
    error,
  };
};
